var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientBgmob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 437,
    viewBox: "0 0 375 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 385.566C56.901 462.261 172.786 349.757 375 309V437H0V385.566Z",
    fill: "url(#paint0_linear_769_458)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C45.5 285 224.609 389.426 375 394.481V437H0V0Z",
    fill: "url(#paint1_linear_769_458)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_769_458",
    x1: 128.776,
    y1: 297.541,
    x2: 83.9812,
    y2: 415.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4499E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3273AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_769_458",
    x1: 128.776,
    y1: 295.963,
    x2: 84.3321,
    y2: 413.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24649F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBgmob);
export default __webpack_public_path__ + "static/media/gradient-bgmob.02159ad840f39de30e64971c24dca416.svg";
export { ForwardRef as ReactComponent };